import type { CoreRequest } from '$api-clients/hooks';

export type MlsSearchResponse =
  CoreRequest<'/mls-services/{mlsVendor}/{mlsNumber}'>['Data'];

type MlsSearchBrokerage = {
  name?: string;
  licenseNumber?: string;
  phone?: string;
  street1?: string;
  street2?: string;
  state?: string;
  city?: string;
  zip?: string;
};

type MlsSearchAgent = {
  firstName?: string;
  lastName?: string;
  email?: string;
  licenseNumber?: string;
  cellPhone?: string;
  brokerage?: MlsSearchBrokerage;
};

type MlsSearchProperty = {
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
  county?: string;
  assessorParcelNumber?: string;
  legalDescription?: string;
  type?: string;
  transactionType?: string;
  bedrooms?: number;
  bathrooms?: number;
  buildingArea?: number;
  lotSize?: number;
  latitude?: number;
  longitude?: number;
};

export type MlsSearchResult = {
  property: MlsSearchProperty;
  listingAgent: MlsSearchAgent | null;
  coListingAgent: MlsSearchAgent | null;
  photos: string[];
  description?: string;
  tourUrl?: string;
};

export enum MlsSearchStatus {
  Found = 'found',
  NotFound = 'notFound',
  InvalidState = 'invalidState',
}

export type MlsSearchOutcome =
  | { status: MlsSearchStatus.Found; result: MlsSearchResult }
  | { status: MlsSearchStatus.NotFound }
  | { status: MlsSearchStatus.InvalidState };
